export enum UrlListEnum {
  PAGE_PAYMENT_PROVIDER_SELECTION = 'payment-provider-selection'
}
